import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  ArrowDown,
  ArrowUp,
  Cabinets,
  Cancel,
  HQBranches,
  LogoAr,
  LogoEn,
  SliderImg1,
  SliderImg2,
} from "../../styled/AllImages";
import { AdminSidebarWrapper } from "./styled";
import { Box, LazyImage, SpanStyled } from "../../styled/Elements";
import { SidebarList } from "../../../helpers/adminConstants/AdminConstants";
import { useUser } from "../../../context/userContext";
import { getModuleOperations, hasPlanFeature } from "../../../utils";
import { Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReferralsApi from "../../../services/api/referralsApi";
import { setSidebarReferralCount } from "../../../store/slices/helperSlice";
const AdminSidebar = ({ sidebarStatus, setSidebarStatus }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const sidebarRef = useRef();
  const { user } = useUser();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { sidebar_referral_count } = useSelector((state) => state.helper);

  const [activeSubMenu, setActiveSubMenu] = useState(
    !user?.onboarding_shown ? 6 : null
  );
  const [filteredSidebarList, setFilteredSidebarList] = useState(SidebarList);
  // const [filteredSidebarList, setFilteredSidebarList] = useState([]);
  const handleSubMenuToggle = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };
  const handleMenuItemClick = (index) => {
    setActiveSubMenu(null);
  };

  const getUserPendingReferrals = async () => {
    try {
      const { data, code } = await ReferralsApi.getUserPendingReferrals();

      if (code === 200) {
        dispatch(setSidebarReferralCount(data?.pending_count ?? 0));
      } 
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!user) return;

    const userType = Number(user.user_type_id);

    // For user type 2 → full sidebar
    let filteredList = [];
    if (userType === 2) {
      filteredList = SidebarList;
    } else if (userType === 6) {
      // For user type 6 → only cabinets
      filteredList = [
        {
          title: "cabinets",
          icon: Cabinets,
          id: 2,
          url: "temporary-cabinets",
        },
      ];
    } else {
      filteredList = SidebarList.map((mainRoute) => {
        // Remove org-structure if not temporary admin director
        if (
          mainRoute.url === "org-structure" &&
          !user.is_temporary_admin_director
        ) {
          return null;
        }

        // Check permissions
        if (mainRoute.permission) {
          const hasPermission = getModuleOperations(
            mainRoute.permission.collection,
            mainRoute.permission.action
          );
          return hasPermission ? mainRoute : null;
        }

        // Filter submenu items
        if (mainRoute.submenu) {
          const filteredSubmenu = mainRoute.submenu.filter(
            (subRoute) =>
              subRoute.url !== "settings/admin-director" &&
              subRoute.url !== "settings/admin-director/edit"
          );
          if (!user.is_temporary_admin_director) {
            const updatedSubMenu = filteredSubmenu.filter(
              (route) => route?.url !== "settings/billing"
            );
            return {
              ...mainRoute,
              submenu: updatedSubMenu,
            };
          } else {
            return {
              ...mainRoute,
              submenu: filteredSubmenu,
            };
          }
        }
        return mainRoute;
      }).filter(Boolean);
    }

    // For user type 3 → add departments item
    if (userType === 3) {
      // filteredList.push({
      //   title: "departments",
      //   icon: HQBranches,
      //   url: `org-structure/departments?org-structure=${user.office_location?.id}`,
      // });
      const newItem = {
        title: "departments",
        icon: HQBranches,
        url: `org-structure/departments?org-structure=${user.office_location?.id}`,
      };

      const insertIndex = Math.max(filteredList.length - 1, 0); // ensures it's valid even if list has 0 or 1 items
      filteredList.splice(insertIndex, 0, newItem);
    }

    // const applyPlanRestrictions = (list) =>
    //   list
    //     .map((route) => {
    //       // If a route has a feature requirement
    //       if (
    //         route.permission?.feature &&
    //         !hasPlanFeature(route.permission.feature)
    //       ) {
    //         return null; // Remove it
    //       }

    //       // If it has a submenu, filter submenu by plan features too
    //       if (route.submenu) {
    //         const allowedSubmenu = route.submenu.filter(
    //           (sub) =>
    //             !sub.permission?.feature ||
    //             hasPlanFeature(sub.permission.feature)
    //         );
    //         return { ...route, submenu: allowedSubmenu };
    //       }

    //       return route;
    //     })
    //     .filter(Boolean);

    // const finalList = applyPlanRestrictions(filteredList);

    setFilteredSidebarList(filteredList);
    getUserPendingReferrals();
  }, [user]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(e.target) &&
        user &&
        user?.onboarding_shown
      ) {
        setSidebarStatus(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [user]);

  return (
    <>
      <AdminSidebarWrapper
        className={`SideBar ${sidebarStatus ? "open" : "close"}`}
        ref={sidebarRef}
      >
        <Box className="text-center">
          <Box className="logo-container d-flex justify-content-between">
            <LazyImage src={LogoEn} />

            <button
              className="border-0 bg-transparent p-0"
              onClick={() => setSidebarStatus(false)}
            >
              <Cancel className="close d-lg-none d-block" />
            </button>
          </Box>
          <Box className="border-seprator"></Box>
          <Box className="sidebar-list custom-scroll">
            <ul className="list-unstyled mb-0 pt-3">
              {filteredSidebarList.map((item, key) => {
                // Check if the current location matches any submenu item to set the parent menu as active
                // const isSubmenuActive = item.submenu && item.submenu.some(subitem => location.pathname.includes(subitem.url));
                const active = location.pathname.includes(item.url)
                  ? "active"
                  : "";
                // const hasSubMenu = item.submenu && item.submenu.length > 0;

                const hasSubMenu = item.submenu && item.submenu.length > 0;

                // Check if the current URL matches the parent menu or any of the submenu items
                const isSubmenuActive =
                  item.submenu &&
                  item.submenu.some((subitem) =>
                    location.pathname.includes(subitem.url)
                  );
                const isParentActive =
                  location.pathname.includes(item.url) || isSubmenuActive;

                // Add active class to parent li if the submenu is active or the parent item is active
                const activeClass = isParentActive ? "active" : "";

                return (
                  // <li key={item.title + key} className="mb-2">
                  <li key={item.title + key} className="mb-2">
                    <Link
                      id={
                        item.title === "cabinets" &&
                        Number(user?.user_type_id) === 6
                          ? undefined
                          : item.title
                      }
                      to={item.url}
                      className={`text-decoration-none d-flex align-items-center ${activeClass} ${active}`}
                      // className={`text-decoration-none d-flex align-items-center ${hasSubMenu && activeSubMenu === key ? "active" : ""} ${activeClass} ${active}`} //Keep Active on Click Submenu
                      onClick={() => {
                        handleMenuItemClick(key);
                        hasSubMenu && handleSubMenuToggle(key);
                        !hasSubMenu && setSidebarStatus(false);
                      }}
                    >
                      <Box className="list-icon mx-2">
                        <item.icon />
                      </Box>
                      <Box className={item.title === "referrals" && `d-flex align-items-center justify-content-between w-100`}>
                        <SpanStyled
                          className="text-capitalize d-flex"
                          style={{ textAlign: "start" }}
                        >
                          {t(item.title)}
                        </SpanStyled>

                        {(item.title === "referrals" && sidebar_referral_count > 0) && (
                          <Badge bg="primary" className="d-flex" style={{ color: 'white', lineHeight: '15px' }}>
                            {sidebar_referral_count}
                          </Badge>
                        )}
                      </Box>
                      {hasSubMenu &&
                        !["users", "temporary-users"].includes(item?.url) && (
                          <Box className="ms-auto subArrow">
                            {activeSubMenu === key ? (
                              <ArrowDown />
                            ) : (
                              <ArrowUp />
                            )}
                          </Box>
                        )}
                    </Link>
                    {hasSubMenu && activeSubMenu === key && (
                      <ul className="subMenu">
                        {item.submenu.map((subitem, subkey) => {
                          return (
                            <li key={subitem.title + subkey}>
                              <Link
                                id={subitem.title}
                                to={subitem.url}
                                className={`text-decoration-none w-100 d-block ${
                                  location.pathname === `/${subitem.url}` &&
                                  "subActive"
                                  // location.pathname.includes(subitem.url) &&
                                  // "subActive"
                                }`}
                                onClick={() => setSidebarStatus(false)}
                              >
                                {t(subitem.title)}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </Box>
        </Box>
      </AdminSidebarWrapper>
    </>
  );
};

export default AdminSidebar;
